"use client";
import React, {useEffect, useRef, useState} from "react";
import { SDialogFC } from "@/Master/SDialogFC/SDialogFC";
import { SDialogProps } from "@/Master/SDialogFC/SDialogFC";
import styles from "./UI.module.css";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";
import {RedeemChannelType} from "@/Core/Redeem/RedeemChannelType";
import RedeemUtil from "@/Core/Redeem/RedeemUtil";

interface RedeemConfirmDialogProps extends SDialogProps {
    onDialogResult?: (isOk: boolean) => void;
    account: string;
    channelType: RedeemChannelType;
}

export const RedeemConfirmDialogFC: React.FC<RedeemConfirmDialogProps> = (props) => {
    const {fcKey, onClose, account,isOpen,channelType} = props;
    const { closeDialog } = useDialogMethods(fcKey);

    function onCloeDialog(ok:boolean = false) {
        closeDialog();
        onClose?.(ok);
    }

    function onAction(ok: boolean) {
        onCloeDialog(ok);
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            isOpen={isOpen}
            mode="Center"
            title={<div style={{
                width: '66%',
                margin: '0 auto',
                fontWeight: '600',
            }}>PLEASE CONFIRM YOUR ACCOUNT</div>}
            onClose={onClose}
            // 按钮数组
            buttons={[
                {label: "Return", onClick: () => onAction(false), style: "blueBtn"},
                {label: "Confirm", onClick: () => onAction(true), style: "greenBtn"},
            ]}
        >
            <div className={`${styles.account} center`}>
                <span>{account}</span>
            </div>
            <div className={`${styles.confirmBody}`} style={{width:'7.6rem',margin:"0 auto"}}>
                <p style={{padding: '0.15rem 0'}}>
                    1.Once confirm your account, <span className={'color-red'}>You be not able to modify it.</span>
                </p>
                <p>
                    2.Please input the correct {RedeemUtil.getChannelName(channelType)} account and ensure it's activated, or <span
                    className={'color-red'}>redemption may fail or be delayed.</span>
                </p>
            </div>
        </SDialogFC>
    );
};
